import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Community } from '@/models/community.model';

class CommunitiesService extends BaseService {
  private url: string = '/api/community';

  constructor() {
    super();
  }

  public async getAll(): Promise<DataResponse<Community[]>> {
    const res = await this.$http.get<Community[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    data: Partial<Community>,
  ): Promise<DataResponse<Community>> {
    const res = await this.$http.post<Community>(this.url, data);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
      message: res.message,
    };
  }

  public async edit(data: Community): Promise<DataResponse<Community>> {
    const res = await this.$http.put<Community>(`${this.url}/${data.id}`, data);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
      message: res.message,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }

  public async removeUser(
    id: number,
    userId: number,
  ): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(
      `${this.url}/${id}/user/${userId}`,
    );

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new CommunitiesService();
